import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const getExistingReview = async (ticketUniqueCode: string, dispenserUniqueCode: string) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/installed-equipment-reviews/ticket/${ticketUniqueCode}/dispenser/${dispenserUniqueCode}`, {
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const saveInstalledEquipmentReview = async (ticketUniqueCode: string, dispenserUniqueCode: string, reviewDTO: any) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/installed-equipment-reviews/ticket/${ticketUniqueCode}/dispenser/${dispenserUniqueCode}`, reviewDTO ,{
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}